// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-previewuielement_default__d32jd"};